"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function moveItem(items, from, to) {
    if (from === to) {
        return items;
    }
    const before = items.slice(0, from);
    const after = items.slice(from + 1);
    const result = before.concat(after);
    result.splice(to, 0, items[from]);
    return result;
}
exports.default = moveItem;
